import cx from 'classnames';
import {NextPage} from 'next';

import {Screen} from '#component/base';
import {withRequireUserState} from '#component/util/RequireUserState/RequireUserState';
import {pageSlideInKeyframe} from '#style/keyframes.css';
import {sprinkles} from '#style/sprinkles';

import {ActiveMember, CancelledMember, DefaultDashboard, Header, PausedMember} from './component';
import {useDashboardState} from './useDashboardState';

export const DashboardScreen = () => {
  const {
    loading,
    firstName,
    mostRecentLabSubmission,
    labSubmissions,
    currentTestPeriod,
    mostRecentLabSubmissionWithResults,
    hasMembership,
    status,
    subscription,
    testKitCheckOutLink,
  } = useDashboardState();

  const renderContent = () => {
    if (hasMembership && subscription) {
      switch (status) {
        case 'ACTIVE':
          return (
            <ActiveMember
              mostRecentLabSubmission={mostRecentLabSubmission}
              labSubmissions={labSubmissions}
              currentTestPeriod={currentTestPeriod}
              mostRecentLabSubmissionWithResults={mostRecentLabSubmissionWithResults}
            />
          );
        case 'PAUSED':
          return <PausedMember />;
        case 'CANCELLED':
          return <CancelledMember />;
      }
    }
    return (
      <DefaultDashboard
        hasSubscription={!!subscription}
        testKitCheckOutLink={testKitCheckOutLink}
        mostRecentLabSubmission={mostRecentLabSubmission}
        labSubmissions={labSubmissions}
        currentTestPeriod={currentTestPeriod}
        mostRecentLabSubmissionWithResults={mostRecentLabSubmissionWithResults}
      />
    );
  };

  return (
    <Screen
      className={sprinkles({bg: 'ecruWhite'})}
      headerProps={{variant: 'dark'}}
      loading={loading}
      pageName="Dashboard"
      withDefaultSizing={false}>
      <Header firstName={firstName} />

      <div
        className={cx(
          sprinkles({layout: 'grid', pB: [40, 72, 128], pos: 'relative'}),
          pageSlideInKeyframe,
        )}>
        {renderContent()}
      </div>
    </Screen>
  );
};

export const Dashboard: NextPage = withRequireUserState(DashboardScreen, {userState: 'verified'});
